<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  <div class='sheet'>
    <h1 class='header'>Raise a new vehicle defect</h1>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-workshop-defect-form [defect]='this.defect'></app-workshop-defect-form>

      <hr />
      <app-workshop-defect-parts mode='local' [(localParts)]='this.pendingParts'></app-workshop-defect-parts>
      <hr />

      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/workshop/defects'>Cancel</button>
    </form>
  </div>
</div>
